export { default } from './PaddedSection';



// WEBPACK FOOTER //
// ./src/components/atoms/PaddedSection/index.js